import axios from 'axios';
import { action } from 'mobx';

import BaseAPIStore, { IAPIStore } from '../api.store';

export class BranchListStore extends BaseAPIStore<IBranch[]> implements IAPIStore {
  constructor() {
    super();
    this.data = [];
  }

  @action
  public async request() {
    const url = this.apiUrl + '/branches';
    this.error = undefined;
    this.requesting = true;
    try {
      const response = await axios.get(url, this.authorizeConfigs());
      const responseData = response.data;
      console.log({ responseData });

      if (responseData.data) {
        this.data = responseData.data;
      } else {
        this.error = new Error('Something went wrong.');
      }
    } catch (error) {
      console.error(error);
      this.error = error;
    }

    this.requesting = false;
  }
}

const branchListStore = new BranchListStore();
export default branchListStore;
